/* ET - Materials Slider — Swiper init (material / component cards, desktop arrows + progress bars)

   Ported from WASDROOM/test/pdp_005, where Swiper was pulled from a CDN at runtime. Impact ships Swiper as
   et-swiper.min.js, loaded just before this file, so both are deferred and execute in document order.
   Init is scoped per `.et-materials` root, which is what lets several sliders stack on one page and each drive
   its own arrows and pagination. */

(function () {
  'use strict';

  if (window.__etMaterialsSliderInit) return;
  window.__etMaterialsSliderInit = true;

  /* In the theme editor a section can be injected after the deferred bundle has already run, and on a cold first
     paint the bundle may not have executed yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function init(root) {
    var el = root.querySelector('[data-et-materials-swiper]');
    if (!el || el.dataset.etInit === 'true') return;
    el.dataset.etInit = 'true';

    var perView = parseInt(el.getAttribute('data-per-view') || '1', 10);
    if (isNaN(perView) || perView < 1) perView = 1;

    whenSwiperReady(function () {
      /* eslint-disable-next-line no-new */
      new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 450,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        a11y: Object.assign({ enabled: true }, window.etSwiperA11y),
        navigation: {
          nextEl: root.querySelector('[data-et-materials-next]'),
          prevEl: root.querySelector('[data-et-materials-prev]')
        },
        pagination: {
          el: root.querySelector('[data-et-materials-pagination]'),
          clickable: true,
          bulletElement: 'button',
          bulletClass: 'et-materials__bar',
          bulletActiveClass: 'is-active'
        },
        breakpoints: {
          /* Matches the desktop breakpoint in et-materials-slider.css. */
          750: { slidesPerView: perView, spaceBetween: 12 }
        }
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.et-materials'), init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  /* Theme editor support. */
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.et-materials'), init);
  });
})();
